export default __webpack_public_path__ + "static/media/klip-logo.7c29513d.svg";